
import { defineComponent, ref } from 'vue'
import { useWalletStore } from '@/stores/wallet'
import { ethers } from 'ethers'

interface Message {
  from: string
  text: string
  datetime: Date
}

import WavePortal from '@/artifacts/solidity/contracts/WavePortal.sol/WavePortal.json'

export default defineComponent({
  name: 'WaveMe',
  components: {},

  setup() {
    const trxInProgress = ref<boolean>(false)

    const walletStore = useWalletStore()
    const contractAddress = process.env.VUE_APP_ADDRESS_WAVE || ''
    const message = ref('')
    const totalWaves = ref(0)
    const allMessages = ref<Message[]>([])

    const getTotalWaves = async function () {
      //@ts-expect-error Window.ethers not TS
      if (typeof window.ethereum !== 'undefined') {
        //@ts-expect-error Window.ethers not TS
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const contract = new ethers.Contract(
          contractAddress,
          WavePortal.abi,
          provider
        )
        try {
          const data = await contract.getTotalWaves({})
          console.log('totalWaves :>> ', data)
          totalWaves.value = data
        } catch (error) {
          console.error(error)
        }
      }
    }

    const getAllWaves = async function () {
      allMessages.value = []

      //@ts-expect-error Window.ethers not TS
      if (typeof window.ethereum !== 'undefined') {
        //@ts-expect-error Window.ethers not TS
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        const contract = new ethers.Contract(
          contractAddress,
          WavePortal.abi,
          provider
        )
        try {
          const data = await contract.getAllWaves({})
          console.log('allWaves :>> ', data)
          data.forEach((wave: any) => {
            allMessages.value.push({
              from: wave.from,
              text: wave.text,
              datetime: new Date(wave.datetime * 1000),
            })
          })
          // allMessages.value = data
        } catch (error) {
          console.error(error)
        }
      }
    }

    const sendMessage = async function () {
      //@ts-expect-error Window.ethers not TS
      if (typeof window.ethereum !== 'undefined') {
        trxInProgress.value = true
        //@ts-expect-error Window.ethers not TS
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        // get the account that will pay for the trasaction
        const signer = provider.getSigner()
        // as the operation we're going to do is a transaction,
        // we pass the signer instead of the provider
        const contract = new ethers.Contract(
          contractAddress,
          WavePortal.abi,
          signer
        )
        try {
          const transaction = await contract.sendWave(message.value, {
            gasLimit: 300000,
          })

          console.log('transaction :>> ', transaction)
          // wait for the transaction to actually settle in the blockchain
          await transaction.wait()
          message.value = ''
          trxInProgress.value = false

          //@ts-expect-error because why not
          this.getAllWaves()
          //@ts-expect-error because why not
          this.getTotalWaves()
        } catch (error) {
          console.error(error)
          trxInProgress.value = false
        }
      }
    }

    return {
      message,
      totalWaves,
      allMessages,
      walletStore,
      trxInProgress,
      sendMessage,
      getAllWaves,
      getTotalWaves,
    }
  },
  mounted() {
    if (this.walletStore.walletData !== null) {
      console.log('There is a wallet connected!')
      this.getTotalWaves()
      this.getAllWaves()
    }
  },
  computed: {
    accAvailable() {
      return useWalletStore().walletData
    },
  },
  watch: {
    accAvailable(newVal, old) {
      console.log(`updating from ${old} to ${newVal}`)
      this.getTotalWaves()
      this.getAllWaves()
    },
  },
})
